'use client'

// React Imports
import type { CSSProperties } from 'react'

import BamaImage from '@/components/BamaImage'

const BamaLogoV2 = ({ color, size = 1 }: { color?: CSSProperties['color']; size?: number }) => {
  return (
    <div className='flex items-center justify-center'>
      <BamaImage
        src='/images/logos/logo-bama.png'
        alt='Bama Logo'
        width={175 * size} // 658 x 240
        height={80 * size} // 951 x 438
        style={{ color, width: 'auto', height: 'auto', maxWidth: '80%' }}
      />
    </div>
  )
}

export default BamaLogoV2
